var _style, _g, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNordeaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-421 250.7 347.4 340.2",
    style: {
      enablebackground: "new -421 250.7 347.4 340.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:none;}\r\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-338.1,440.8L-338.1,440.8c-10,0-18.2-8.1-18.2-18.2v-54.5c0-10,8.1-18.2,18.2-18.2l0,0 c10,0,18.2,8.1,18.2,18.2v54.5C-320,432.6-328.1,440.8-338.1,440.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-112.8,438.9L-112.8,438.9c-6,0-10.9-4.9-10.9-10.9v-14.6c0-6,4.9-10.9,10.9-10.9l0,0c6,0,10.9,4.9,10.9,10.9 V428C-101.9,434.1-106.8,438.9-112.8,438.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-381.8,438.9L-381.8,438.9c-6,0-10.9-4.9-10.9-10.9v-14.6c0-6,4.9-10.9,10.9-10.9l0,0c6,0,10.9,4.9,10.9,10.9 V428C-370.9,434.1-375.8,438.9-381.8,438.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-156.4,491.6L-156.4,491.6c-10,0-18.2-8.1-18.2-18.2v-54.5c0-10,8.1-18.2,18.2-18.2l0,0 c10,0,18.2,8.1,18.2,18.2v54.5C-138.3,483.5-146.4,491.6-156.4,491.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-279.1,482.6L-279.1,482.6c-12.5,0-22.7-10.2-22.7-22.7V301.8c0-12.5,10.2-22.7,22.7-22.7l0,0 c12.5,0,22.7,10.2,22.7,22.7v158.1C-256.4,472.4-266.5,482.6-279.1,482.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-215.5,562.5L-215.5,562.5c-12.5,0-22.7-10.2-22.7-22.7V381.7c0-12.5,10.2-22.7,22.7-22.7l0,0 c12.5,0,22.7,10.2,22.7,22.7v158.1C-192.8,552.3-202.9,562.5-215.5,562.5z"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -421,
    y: 250.7,
    className: "st1",
    width: 347.4,
    height: 340.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNordeaLogo);
export default __webpack_public_path__ + "static/media/nordea-logo.a144bceebee37fc8c4d6de7aa271c200.svg";
export { ForwardRef as ReactComponent };